export const REPORT_STATUSES = [
    { value: 'done', label: 'Сформирована', bgColor: '#A1E6C3' },
    { value: 'scheduled', label: 'Формируется', bgColor: '#B2D9FD' },
    { value: 'error', label: 'Ошибка', bgColor: '#FF6767' }
]
